import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filter: "All",
    searchKeyword: ""
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        toggleFilter: (state, action) => {
            state.filter = action.payload
        },
        searchBook : (state, action) => {
            state.searchKeyword = action.payload
        }
    }

})

export default filterSlice.reducer;
export const { toggleFilter, searchBook } = filterSlice.actions;